import { registerPlugin } from '@capacitor/core';

const JStyle = registerPlugin('JStyle');

export default JStyle;